module.exports = __webpack_public_path__ + "img/wood.b0990c90.jpg";